import React, { useEffect, } from 'react';

const MapaDetalhado = ({ setCurrentPage }: { setCurrentPage?: Function; }) => {


    useEffect(() => {
        if (setCurrentPage)
            setCurrentPage(window.location.pathname);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className="modal fade" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                        <div className="modal-body p-0">
                            <div className="card-body overflow-hidden h-100" >
                                <button type="button" className="btn btn-danger m-3 position-absolute" data-bs-dismiss="modal" style={{ top: 40 }}>Fechar</button>
                                <iframe
                                    src="https://www.meteoblue.com/pt/tempo/mapas/widget?windAnimation=0&windAnimation=1&gust=0&gust=1&satellite=0&satellite=1&cloudsAndPrecipitation=0&cloudsAndPrecipitation=1&temperature=0&temperature=1&sunshine=0&sunshine=1&extremeForecastIndex=0&extremeForecastIndex=1&geoloc=detect&tempunit=C&windunit=km%252Fh&lengthunit=metric&zoom=5&autowidth=auto"
                                    sandbox="allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox"
                                    style={{ width: "100%", height: "100%" }}
                                    title='MapaDetalhado'>
                                </iframe>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div className="card m-2">
                <div className="card-header d-flex justify-content-between text-center align-items-end">
                    <div></div>
                    <h5 className="text-center">
                        Mapa Detalhado
                    </h5>
                    <button type="button" className="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#exampleModal">
                        <i className="bi bi-arrows-angle-expand"></i>
                    </button>
                </div>
                <div className="card-body">
                    <iframe
                        src="https://www.meteoblue.com/pt/tempo/mapas/widget?windAnimation=0&windAnimation=1&gust=0&gust=1&satellite=0&satellite=1&cloudsAndPrecipitation=0&cloudsAndPrecipitation=1&temperature=0&temperature=1&sunshine=0&sunshine=1&extremeForecastIndex=0&extremeForecastIndex=1&geoloc=detect&tempunit=C&windunit=km%252Fh&lengthunit=metric&zoom=5&autowidth=auto"
                        sandbox="allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox"
                        style={{ width: "100%", minHeight: "55rem" }}
                        title='Mapa'>
                    </iframe>
                </div>
            </div >
        </>
    );
};

export default MapaDetalhado;
